import { object, string } from 'yup';
import text from '../text';
export var companyFormSchema = object().shape({
    name: string().required(text('required'))
});
